/**
 * 个人资料 API。个人中心 W-22 身份卡 + 发布守卫链第 3 层(昵称)+ 编辑资料页。
 *   GET  /api/v1/users/me/profile → ProfileResponse { nickname, avatar, bio, adjustedNickname? }
 *   POST /api/v1/users/me/profile { nickname?, bio?, avatarUrl? } → ProfileResponse(更新后)
 * 需 REGISTERED,userId 取自 JWT。
 */
import { call } from './client';
import type { components } from './openapi.generated';

type Schemas = components['schemas'];
export type ProfileResponse = Schemas['ProfileResponse'];
export type UpdateProfileRequest = Schemas['UpdateProfileRequest'];

/** 当前登录用户 profile(nickname/avatar/bio)。userId 取自 JWT。 */
export function getMyProfile(): Promise<ProfileResponse> {
  return call<ProfileResponse>({ method: 'GET', url: '/api/v1/users/me/profile' });
}

/** 更新资料(昵称/简介/头像 URL,均可空表示不改)。返回更新后的 profile。 */
export function updateProfile(req: UpdateProfileRequest): Promise<ProfileResponse> {
  return call<ProfileResponse>({ method: 'POST', url: '/api/v1/users/me/profile', data: req });
}
